module.exports = __webpack_public_path__ + "pic1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic1.jpg
// module id = 1521
// module chunks = 13